var _use, _symbol, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 101,
    width: 101,
    viewBox: "0 0 61 81",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0072c6",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.929v58.14C0 75.106 13.432 80 30 80V10.929H0z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    opacity: 0.15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 10.929c0 6.036-13.432 10.929-30 10.929S0 16.965 0 10.929 13.432 0 30 0s30 4.893 30 10.929",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.866 10.299c0 3.985-10.685 7.211-23.866 7.211S6.132 14.284 6.132 10.299 16.819 3.088 30 3.088s23.866 3.228 23.866 7.211",
    fill: "#7fba00",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.867 14.707c3.124-1.219 5.002-2.745 5.002-4.404C53.868 6.318 43.183 3.09 30 3.09S6.134 6.318 6.134 10.303c0 1.658 1.877 3.185 5.002 4.404 4.363-1.704 11.182-2.803 18.865-2.803s14.5 1.099 18.866 2.803",
    fill: "#b8d432",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.472 51.287c0 1.807-.651 3.206-1.955 4.197s-3.102 1.488-5.399 1.488c-1.954 0-3.587-.354-4.899-1.063v-4.251c1.514 1.293 3.182 1.94 5.004 1.94.88 0 1.561-.177 2.041-.532s.72-.823.72-1.409c0-.575-.231-1.075-.693-1.5s-1.402-.974-2.819-1.647c-2.888-1.362-4.331-3.224-4.331-5.577 0-1.708.629-3.078 1.889-4.11s2.931-1.547 5.016-1.547c1.849 0 3.379.245 4.596.731v3.971c-1.276-.886-2.729-1.328-4.357-1.328-.818 0-1.465.174-1.94.523a1.65 1.65 0 0 0-.712 1.401c0 .602.191 1.096.575 1.481s1.168.861 2.356 1.428c1.77.842 3.03 1.695 3.784 2.563s1.125 1.95 1.125 3.241zm20.37-4.302c0 2.24-.507 4.185-1.519 5.83s-2.438 2.801-4.277 3.466l5.491 5.113h-5.544l-3.921-4.423c-1.681-.061-3.198-.509-4.549-1.341s-2.395-1.972-3.129-3.42-1.103-3.062-1.103-4.841c0-1.974.398-3.734 1.194-5.279s1.916-2.734 3.36-3.566 3.097-1.248 4.965-1.248c1.741 0 3.302.403 4.68 1.209s2.446 1.951 3.208 3.439 1.144 3.175 1.144 5.06zm-4.488.24c0-1.931-.418-3.455-1.255-4.576s-1.98-1.681-3.433-1.681c-1.479 0-2.662.562-3.552 1.685s-1.333 2.621-1.333 4.489c0 1.86.435 3.344 1.306 4.455s2.028 1.666 3.472 1.666c1.471 0 2.636-.538 3.499-1.613s1.296-2.55 1.296-4.426zm18.893 9.414H43.972V37.596h4.264V53.16h7.01z",
    stroke: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M29.589 79.999H30c16.568 0 30-4.892 30-10.929v-58.14H29.589v69.07z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.5034c9131bfbc9fc684880f970ea0a8a.svg";
export { ForwardRef as ReactComponent };